/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Main/Layout";
import CustomTable from "../../components/Custom/Table/CustomTable";
import { get, put, post, patch } from "../../config/axios";
import { Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Searchbar from "../../components/Custom/SearchBar/Searchbar";
import DeleteModal from "../../components/Custom/DeleteModal/DeleteModal";
import { deleteAPI } from "../../helper/apiCallHelper";
import { useDebouncedValue } from "../../helper/debounce";
import { toastMessage } from "../../utils/toastMessage";
import FormModal from "../../components/Custom/FormModal/FormModal";
import { faqTableColumns, faqFormFields } from "../../constants/FAQPage";
const Users = () => {
  const [users, setUsers] = useState([]);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [search, setSearch] = useState("");
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const debouncedSearch = useDebouncedValue(search, 500);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const category = "6594f595afa5f6ef86f9003f";

  const fetchUsers = async (searchValue) => {
    try {
      setLoading(true);
      const res = await get(
        `/api/dashboard/apputility/getAppContent?page=${page}&limit=${10}&search=${searchValue}&category=${category}&type=FAQ`
      );
      
      const mappedData = res?.data.map((item) => ({
        ...item,
        action: { edit: true, delete: true },
      }));
      
      setUsers(mappedData);
      setLoading(false);
      setPageCount(res?.totalPage);
      setTotalData(res?.totalData);
      setPerPage(res?.perPage);
      setCurrentPage(res?.currentPage);
      
      // Show toast message when no results found for search
      // if (searchValue && searchValue.trim() !== "" && (!res?.data || res?.data.length === 0)) {
      //   toastMessage("No FAQs found for your search.", "info");
      // }
      
      setMessage("");
    } catch (err) {
      console.error("Error:", err);
      setLoading(false);
      toastMessage("Error fetching FAQs. Please try again.", "error");
    }
  };

  useEffect(() => {
    if (search === "") {
      fetchUsers("");
    } else if (debouncedSearch) {
      fetchUsers(debouncedSearch);
    }
  }, [search, debouncedSearch, message, page]);

  const handleEdit = (row) => {
    // Implement the edit action for the selected row
    openModal("edit", row);
  };

  const handleDelete = (row) => {
    openModal("delete", row);
  };

  const handleDeleteUser = async (row) => {
    try {
      const deletedDietContent = await patch(
        `/api/dashboard/apputility/deleteAppContent/${row._id}`
      );
      setMessage(deletedDietContent?.message);
      toastMessage(deletedDietContent?.message, "success");
    } catch (error) {
      console.error(error);
      setMessage("Something went wrong!");
      toastMessage("Something went wrong!", "error");
    }
    setDeleteModalOpen(false);
  };

  const handleStatus = (row) => {
    // Implement the status chnage for the selected row
    console.log("Delete clicked for row34:", row);
  };

  const handleActive = async (id, active) => {
    setLoading(true);
    let response = await put(
      `/api/dashboard/apputility/updateAppContent?id=${id}`,
      {
        active: active,
      }
    );
    setLoading(false);
    const title = response.data.title;
    const message = active
      ? `${title} has been successfully activated.`
      : `${title} has been successfully deactivated.`;
    setMessage(message);
    toastMessage(message, "success");
  };

  const handleSearch = (searchText) => {
    setSearch(searchText.trim());
    setPage(1);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const handleChange = (page) => {
    setPage(page);
  };

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      setEditModal(true);
      setEditData(dataForEdit);
    } else if (type === "delete") {
      setDeleteModalOpen(true);
      setDeleteUser(dataForEdit);
    }
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (formData, isEditing, id) => {
    setLoading(true);
    try {
      if (isEditing) {
        formData = {
          ...formData,
          category: `${category}`,
          type: "FAQ",
          assets: [],
        };

        const { ...data } = formData;
        let response = await put(
          `/api/dashboard/apputility/updateAppContent?id=${id}`,
          data
        );
        setMessage(response.message);
        toastMessage(response.message, "success");
        setEditModal(false);
        setEditData({});
        fetchUsers("");
      } else {
        formData = {
          ...formData,
          category: `${category}`,
          type: "FAQ",
          assets: [],
        };
        const { ...data } = formData;

        const res = await post("/api/dashboard/apputility/addAppContent", data);
        if (!res || res.status === 400) {
          toastMessage(res.message.message, "error");
        } else {
          setMessage("Successfully added");
          toastMessage(res.data.message, "success");
          setIsModalOpen(false);
          fetchUsers("");
        }
      }
    } catch (err) {
      console.error("Error:", err);
      setMessage("Error while processing the request");
      toastMessage("Error while updating", "error");
    }
    setLoading(false);
  };

  return (
    <>
      <Layout>
        <div style={{ padding: "1rem" }}>
          <Typography variant="h5">FAQs</Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ width: "40%" }}>
              <Searchbar
                search={handleSearch}
                placeholder={"Search by question"}
                debounceTime={1000}
              />
            </div>

            <Button
              onClick={() => openModal("add")}
              variant="outlined"
              startIcon={<AddIcon fontSize="large" />}
              style={{ fontWeight: "bold" }}
            >
              add FAQ
            </Button>
          </div>
          <CustomTable
            data={users}
            columns={faqTableColumns}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleStatus={handleStatus}
            handleActive={(row, active) => handleActive(row, active)}
            handlePageChange={(page) => handleChange(page)}
            pageNumber={page}
            pageCount={pageCount}
            totalData={totalData}
            perPage={perPage}
            currentPage={currentPage}
            loading={loading}
          />
          {search && users.length === 0 && !loading && (
            <Typography variant="body1" sx={{ color: 'red', textAlign: 'center', mt: 2 }}>
              No FAQs found for your search.
            </Typography>
          )}
        </div>
      </Layout>
      <DeleteModal
        open={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onDelete={handleDeleteUser}
        data={deleteUser}
      />
      <FormModal
        isOpen={isModalOpen || editModal}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        fields={faqFormFields}
        header={editModal ? "Edit FAQ" : "Add FAQ"}
        initialData={editData}
        isEditing={editModal}
      />
    </>
  );
};

export default Users;
